import { TextFilterProps } from '@progress/kendo-react-data-tools'
import { useAppSelector } from 'store'

import { MultiSelectFilter } from '../MultiSelectFilter'

export const WorldCheckStatusFilter: React.FC<TextFilterProps> = (props) => {
  const { filter, onFilterChange } = props
  const screeningStatuses = useAppSelector(
    (state) => state.compliance.worldCheckTypes.screeningStatuses
  )
  const data = screeningStatuses.map((x) => ({ id: x.id, label: x.name, value: x.id }))

  return (
    <MultiSelectFilter
      placeholder='Status'
      filter={filter}
      onFilterChange={onFilterChange}
      data={data}
    />
  )
}
